export default "__VITE_ASSET__cUZezy5d__"